// Sole remaining client-side time math.
//
// Snapshot totals (.headline.*, .active_session.current_session_active_s,
// .active_session.current_task_total_s) already include in-flight time
// through snapshot.published_at. The browser advances ONLY from
// published_at forward. Do NOT use block_open_epoch as the UI delta
// anchor; the snapshot already accounted for it, and adding (now -
// block_open_epoch) on top would double-count the period from
// block_open_epoch to published_at.

import type { Snapshot } from './types';

// A live delta is only meaningful while the snapshot it advances from is
// itself fresh. If polling has been failing, published_at recedes without
// bound and (now - published_at) becomes fiction: a 2026-07-14 session
// rendered 221h29m of "live" time from a snapshot stranded on 2026-07-05.
// Past this bound the honest answer is "unknown", not a bigger number, so
// the counter stops and the UI reports staleness instead.
export const LIVE_DELTA_MAX_S = 120;

export function isLiveDeltaTrustworthy(snapshot: Snapshot | null, nowS: number): boolean {
  if (!snapshot) return false;
  const age = nowS - snapshot.published_at;
  return age >= 0 && age <= LIVE_DELTA_MAX_S;
}

export function liveDelta(snapshot: Snapshot | null, nowS: number): number {
  if (!snapshot || !snapshot.active_session) return 0;
  if (snapshot.active_session.is_paused) return 0;
  if (!isLiveDeltaTrustworthy(snapshot, nowS)) return 0;
  return Math.max(0, nowS - snapshot.published_at);
}

export function nowSeconds(): number {
  return Math.floor(Date.now() / 1000);
}
